<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white">
    <div class="container">
      <router-link :to="{ name: user ? 'home' : 'home' }" class="navbar-brand">
        {{ appName }}
      </router-link>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false">
        <span class="navbar-toggler-icon"/>
      </button>

      <div id="navbarToggler" class="collapse navbar-collapse">
        <ul class="navbar-nav" v-if="user && user.is_admin">
          <li class="nav-item">
            <router-link class="nav-link" :to="{name: 'users.list'}">Benutzer</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{name: 'institutions.list'}">Einrichtungen</router-link>
          </li>
<!--          <li class="nav-item">-->
<!--            <router-link class="nav-link" :to="{name: 'approvals.list'}">Freigabe</router-link>-->
<!--          </li>-->
        </ul>

        <ul class="navbar-nav" v-else>
          <li class="nav-item" v-if="hasPanels">
            <router-link class="nav-link" :to="{name: 'home'}">
              News
            </router-link>
          </li>
          <li class="nav-item" v-if="hasPublications">
            <router-link class="nav-link" :to="{name: 'publications'}">
              Publikationen
            </router-link>
          </li>
          <li class="nav-item" v-if="hasBlog">
            <router-link class="nav-link" :to="{name: 'blog.list'}">
              Blog
            </router-link>
          </li>
          <li class="nav-item" v-if="hasMicroscopes">
            <router-link class="nav-link" :to="{name: 'microscopes.list'}">
              Mikroskope
            </router-link>
          </li>
          <li class="nav-item" v-if="hasMicroscopes">
            <router-link class="nav-link" :to="{name: 'microscope-filters.list'}">
              Mikroskop-Filter
            </router-link>
          </li>
        </ul>

        <ul class="navbar-nav ml-auto">
          <!-- Authenticated -->
          <li v-if="user" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle text-dark"
               href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ user.name }}
            </a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'settings.profile' }" class="dropdown-item pl-3">
                <fa icon="cog" fixed-width/>
                {{ $t('settings') }}
              </router-link>

              <div class="dropdown-divider"/>
              <a href="#" class="dropdown-item pl-3" @click.prevent="logout">
                <fa icon="sign-out-alt" fixed-width/>
                {{ $t('logout') }}
              </a>
            </div>
          </li>
          <!-- Guest -->
          <template v-else>
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" class="nav-link" active-class="active">
                {{ $t('login') }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'

export default {
  components: {
    LocaleDropdown
  },

  data: () => ({
    appName: window.config.appName
  }),

  computed: {
      ...mapGetters({
          user: 'auth/user'
      }),
      hasPublications()
      {
          for (let i in this.user.institutions)
          {
              if (this.user.institutions[i].has_publications)
              {
                  return true
              }
          }

          return false
      },
      hasBlog()
      {
          for (let i in this.user.institutions)
          {
              if (this.user.institutions[i].has_blog)
              {
                  return true
              }
          }

          return false
      },
      hasPanels()
      {
          for (let i in this.user.institutions)
          {
              if (this.user.institutions[i].has_panels)
              {
                  return true
              }
          }

          return false
      },
      hasMicroscopes()
      {
          for (let i in this.user.institutions)
          {
              if (this.user.institutions[i].has_microscopes)
              {
                  return true
              }
          }

          return false
      }
  },

  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Navbar.vue